<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="container-fluid">
                    <form id="FormPregunta" role="form" method="post" autocomplete="off" onSubmit="return false">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <label class="form-label" for="Pregunta">Pregunta</label>
                                <input type="text" id="Pregunta" class="form-control" v-model="objConfigEncuestaPregunta.Pregunta" placeholder="Agregar Pregunta">
                                <CValidation v-if="this.errorvalidacion.Pregunta" :Mensaje="'*'+errorvalidacion.Pregunta[0]"/>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                <label class="form-label" for="TipoPregunta">Tipo de Pregunta</label>
                                <select @change="AjustarMostrarTipoRespuesta" name="" id="" class="form-control form-select" v-model="objConfigEncuestaPregunta.TipoPregunta">
                                    <option value="">Seleccione una Opción</option>
                                    <option value="1">Opciones por Defecto</option>
                                    <option value="2">Encuesta</option>
                                    <option value="3">Anexar</option>
                                    <option value="4">Valoración 1 - 10</option>
                                    <option value="5">Si - No</option>
                                    <option value="6">Preguntas Abiertas</option>
                                </select>
                                <CValidation v-if="this.errorvalidacion.TipoPregunta" :Mensaje="'*'+errorvalidacion.TipoPregunta[0]"/>
                            </div>
                            <div v-show="MostrarTipoRespuesta" class="col-12 col-sm-12 col-md-6 col-lg-6">
                                <label class="form-label" for="TipoRespuesta">Tipo de Respuesta</label>
                                <select name="" id="" class="form-control form-select" v-model="objConfigEncuestaPregunta.TipoRespuesta">
                                    <option value="">Seleccione una Opción</option>
                                    <option value="UNICO">Único</option>
                                    <option value="MULTIPLE">Múltiple</option>
                                </select>
                                <CValidation v-if="this.errorvalidacion.TipoRespuesta" :Mensaje="'*'+errorvalidacion.TipoRespuesta[0]"/>
                            </div>
                        </div>
                    </form>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>
export default {
    name: 'FormPregunta',
    props: ['poBtnSave','IdConfigEncuesta'],

    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objConfigEncuestaPregunta:{
                IdConfigEncuestaPregunta:0,
                Pregunta:'',
                IdConfigEncuesta:0,
                TipoPregunta:'',
                TipoRespuesta:'',
            },
            segurity: {},
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            MostrarTipoRespuesta:false
        }
    },
    methods: {
        async Guardar(){
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            if (this.objConfigEncuestaPregunta.IdConfigEncuestaPregunta==0) {
                await this.$http.post('configEncuestaPreguntas/',this.objConfigEncuestaPregunta
                ).then((res) => {
                    this.EjecutaConExito(res);
                }).catch((err) => {
                    this.EjecutaConError(err);
                });
            }
            else{
                await this.$http.put('configEncuestaPreguntas/'+this.objConfigEncuestaPregunta.IdConfigEncuestaPregunta,this.objConfigEncuestaPregunta
                ).then((res) => {
                    this.EjecutaConExito(res);
                }).catch((err) => {
                    this.EjecutaConError(err);
                });
            }
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get('configEncuestaPreguntas/'+this.objConfigEncuestaPregunta.IdConfigEncuestaPregunta
            ).then((res)=>{
                this.objConfigEncuestaPregunta=res.data.data;
                this.AjustarMostrarTipoRespuesta();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar(){
            this.objConfigEncuestaPregunta={
                IdConfigEncuestaPregunta:0,
                Pregunta:'',
                IdConfigEncuesta:0,
                TipoPregunta:'',
                TipoRespuesta:'',
            }
            this.MostrarTipoRespuesta=false;
        },
        AjustarMostrarTipoRespuesta(){
            if (this.objConfigEncuestaPregunta.TipoPregunta=='1' || this.objConfigEncuestaPregunta.TipoPregunta=='2' || this.objConfigEncuestaPregunta.TipoPregunta=='3') {
                this.MostrarTipoRespuesta=true;
            }
            else{
                this.MostrarTipoRespuesta=false;
                this.objConfigEncuestaPregunta.TipoRespuesta="";
            }
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            if (Id!='') 
            {
                this.objConfigEncuestaPregunta.IdConfigEncuestaPregunta = Id;
                this.Recuperar();
            }
            else
            {
                this.objConfigEncuestaPregunta.IdConfigEncuesta=this.IdConfigEncuesta;
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>

<style>

</style>